import type { AreaDict } from '../messages'

// Relatórios (ReportsPage), Patrimônio (NetWorthPage) e diálogo de item (NetWorthItemDialog).
// Prefixo `rep`. pt-BR = textos atuais do app.
const reports: AreaDict = {
  'pt-BR': {
    // ReportsPage — cabeçalho, abas e período
    'rep.title': 'Relatórios',
    'rep.subtitle': 'Evolução no tempo — uma fotografia por mês.',
    'rep.tabBudget': 'Orçamento',
    'rep.tabNetworth': 'Patrimônio',
    'rep.periodMonths': '{n} meses',
    'rep.periodAll': 'Tudo',
    'rep.noDataTitle': 'Sem dados ainda',
    // ReportsPage — aba patrimônio
    'rep.networthEmptyDesc':
      'O gráfico de patrimônio é montado a partir de uma fotografia mensal das suas contas e itens. Conforme os meses passam e cada fechamento é registrado, a evolução aparece aqui.',
    'rep.networthChartTitle': 'Patrimônio ao fim de cada mês',
    'rep.seriesAccountsCards': 'Contas + cartões',
    'rep.seriesItems': 'Itens (imóveis, empréstimos)',
    'rep.seriesTotal': 'Patrimônio total',
    'rep.itemsNoteA': 'A linha de "Itens" é constante no passado — de propósito.',
    'rep.itemsNoteB': 'Contas e cartões têm histórico',
    'rep.itemsNoteC': 'real',
    'rep.itemsNoteD':
      '(reconstruído das transações), então toda a variação que você vê no passado vem deles. Já os itens (imóvel, FGTS, empréstimos) guardam só o',
    'rep.itemsNoteE': 'valor atual',
    'rep.itemsNoteF': ': repetimos esse valor para trás porque mudam pouco, mas',
    'rep.itemsNoteG': 'não é medição histórica',
    'rep.itemsNoteH':
      '— o empréstimo amortizado e o FGTS rendido de meses atrás não estão refletidos. De agora em diante o valor é fotografado todo mês, e qualquer alteração em Patrimônio já aparece aqui.',
    'rep.thMonth': 'Mês',
    'rep.thAccountsCards': 'Contas + cartões',
    'rep.thItems': 'Itens',
    'rep.thTotal': 'Total',
    // ReportsPage — aba orçamento
    'rep.budgetEmptyDesc':
      'Este gráfico compara receitas e despesas mês a mês. Assim que você lançar transações ou definir orçamentos, a sobra de cada mês e a evolução acumulada aparecem aqui.',
    'rep.surplusMonthTitle': 'Sobra do mês (receitas − despesas)',
    'rep.projectFuture': 'Projetar meses futuros',
    'rep.barDescA': 'Barras: verde = sobrou · vermelho = faltou ·',
    'rep.barDescB': 'vazada = projeção',
    'rep.barDescC': '. A linha é a',
    'rep.barDescD': 'sobra acumulada',
    'rep.barDescE':
      '— a posição real de contas + cartões no fim de cada mês, o mesmo número que o Orçamento herda como "sobra do mês anterior".',
    'rep.barName': 'Sobra',
    'rep.lineAccumulated': 'Sobra acumulada (contas + cartões)',
    'rep.thIncome': 'Receitas',
    'rep.thExpenses': 'Despesas',
    'rep.thSurplus': 'Sobra',
    'rep.thAccumulated': 'Acumulada',
    'rep.projectionBadge': 'projeção',
    // NetWorthPage
    'rep.nwTitle': 'Patrimônio',
    'rep.nwSubtitle': 'Net worth: contas + bens − cartões − dívidas, consolidado em {currency}.',
    'rep.nwNetWorthLabel': 'Patrimônio líquido (net worth)',
    'rep.nwAssets': 'Ativos',
    'rep.nwLiabilities': 'Passivos',
    'rep.nwPartial': '* parcial: alguma moeda sem taxa em cache.',
    'rep.nwGroupCards': 'Cartões',
    'rep.nwGroupAccounts': 'Contas',
    'rep.nwDeleteConfirmTitle': 'Excluir "{name}"?',
    'rep.nwDeleteConfirmDesc': 'Esta ação não pode ser desfeita.',
    'rep.nwItemDeleted': 'Item excluído',
    'rep.nwDeleteError': 'Erro ao excluir',
    'rep.nwSectionEmptyTitle': 'Nada aqui ainda',
    'rep.nwSectionEmptyDesc': 'Nenhum item em {name} por enquanto.',
    'rep.nwBadgeCard': 'cartão',
    'rep.nwBadgeAccount': 'conta',
    'rep.nwCreditSuffix': 'crédito',
    // NetWorthItemDialog
    'rep.dlgEditTitle': 'Editar item',
    'rep.dlgNewTitle': 'Novo item de patrimônio',
    'rep.dlgDesc': 'O tipo define se é ativo (bem) ou passivo (dívida) e agrupa no resumo.',
    'rep.dlgTypeLabel': 'Tipo',
    'rep.dlgAssetsGroup': 'Ativos (bens)',
    'rep.dlgLiabilitiesGroup': 'Passivos (dívidas)',
    'rep.dlgAsset': 'Ativo',
    'rep.dlgLiability': 'Passivo',
    'rep.dlgExamples': '· ex.: {examples}',
    'rep.dlgNameLabel': 'Nome',
    'rep.dlgNamePlaceholder': 'Ex.: Apartamento, Carro, Empréstimo…',
    'rep.dlgValueLabel': 'Valor',
    'rep.dlgCurrencyLabel': 'Moeda',
    'rep.dlgNotesLabel': 'Observações',
    'rep.dlgNotesPlaceholder': 'Opcional',
    'rep.dlgItemUpdated': 'Item atualizado',
    'rep.dlgItemAdded': 'Item adicionado',
    'rep.dlgSaveError': 'Erro ao salvar',
    'rep.valName': 'Informe um nome',
    'rep.valType': 'Selecione o tipo',
    'rep.valValueInvalid': 'Valor inválido',
    'rep.valValueNegative': 'Valor não pode ser negativo',
  },
  en: {
    'rep.title': 'Reports',
    'rep.subtitle': 'Evolution over time — one snapshot per month.',
    'rep.tabBudget': 'Budget',
    'rep.tabNetworth': 'Net worth',
    'rep.periodMonths': '{n} months',
    'rep.periodAll': 'All',
    'rep.noDataTitle': 'No data yet',
    'rep.networthEmptyDesc':
      'The net worth chart is built from a monthly snapshot of your accounts and items. As the months pass and each closing is recorded, the evolution appears here.',
    'rep.networthChartTitle': 'Net worth at the end of each month',
    'rep.seriesAccountsCards': 'Accounts + cards',
    'rep.seriesItems': 'Items (real estate, loans)',
    'rep.seriesTotal': 'Total net worth',
    'rep.itemsNoteA': 'The "Items" line is flat in the past — on purpose.',
    'rep.itemsNoteB': 'Accounts and cards have a',
    'rep.itemsNoteC': 'real',
    'rep.itemsNoteD':
      'history (rebuilt from transactions), so all the variation you see in the past comes from them. Items (property, FGTS, loans), on the other hand, store only the',
    'rep.itemsNoteE': 'current value',
    'rep.itemsNoteF': ': we repeat that value backwards because they change little, but',
    'rep.itemsNoteG': 'it is not a historical measurement',
    'rep.itemsNoteH':
      '— the amortized loan and the FGTS earnings from past months are not reflected. From now on the value is snapshotted every month, and any change in Net worth already shows up here.',
    'rep.thMonth': 'Month',
    'rep.thAccountsCards': 'Accounts + cards',
    'rep.thItems': 'Items',
    'rep.thTotal': 'Total',
    'rep.budgetEmptyDesc':
      "This chart compares income and expenses month by month. As soon as you record transactions or set budgets, each month's surplus and the accumulated evolution appear here.",
    'rep.surplusMonthTitle': 'Monthly surplus (income − expenses)',
    'rep.projectFuture': 'Project future months',
    'rep.barDescA': 'Bars: green = surplus · red = shortfall ·',
    'rep.barDescB': 'hollow = projection',
    'rep.barDescC': '. The line is the',
    'rep.barDescD': 'accumulated surplus',
    'rep.barDescE':
      '— the real position of accounts + cards at the end of each month, the same number the Budget inherits as "previous month\'s surplus".',
    'rep.barName': 'Surplus',
    'rep.lineAccumulated': 'Accumulated surplus (accounts + cards)',
    'rep.thIncome': 'Income',
    'rep.thExpenses': 'Expenses',
    'rep.thSurplus': 'Surplus',
    'rep.thAccumulated': 'Accumulated',
    'rep.projectionBadge': 'projection',
    'rep.nwTitle': 'Net worth',
    'rep.nwSubtitle': 'Net worth: accounts + assets − cards − debts, consolidated in {currency}.',
    'rep.nwNetWorthLabel': 'Net worth',
    'rep.nwAssets': 'Assets',
    'rep.nwLiabilities': 'Liabilities',
    'rep.nwPartial': '* partial: some currency without a cached rate.',
    'rep.nwGroupCards': 'Cards',
    'rep.nwGroupAccounts': 'Accounts',
    'rep.nwDeleteConfirmTitle': 'Delete "{name}"?',
    'rep.nwDeleteConfirmDesc': 'This action cannot be undone.',
    'rep.nwItemDeleted': 'Item deleted',
    'rep.nwDeleteError': 'Error deleting',
    'rep.nwSectionEmptyTitle': 'Nothing here yet',
    'rep.nwSectionEmptyDesc': 'No items in {name} for now.',
    'rep.nwBadgeCard': 'card',
    'rep.nwBadgeAccount': 'account',
    'rep.nwCreditSuffix': 'credit',
    'rep.dlgEditTitle': 'Edit item',
    'rep.dlgNewTitle': 'New net worth item',
    'rep.dlgDesc': 'The type defines whether it is an asset (property) or a liability (debt) and groups it in the summary.',
    'rep.dlgTypeLabel': 'Type',
    'rep.dlgAssetsGroup': 'Assets (property)',
    'rep.dlgLiabilitiesGroup': 'Liabilities (debts)',
    'rep.dlgAsset': 'Asset',
    'rep.dlgLiability': 'Liability',
    'rep.dlgExamples': '· e.g.: {examples}',
    'rep.dlgNameLabel': 'Name',
    'rep.dlgNamePlaceholder': 'E.g.: Apartment, Car, Loan…',
    'rep.dlgValueLabel': 'Value',
    'rep.dlgCurrencyLabel': 'Currency',
    'rep.dlgNotesLabel': 'Notes',
    'rep.dlgNotesPlaceholder': 'Optional',
    'rep.dlgItemUpdated': 'Item updated',
    'rep.dlgItemAdded': 'Item added',
    'rep.dlgSaveError': 'Error saving',
    'rep.valName': 'Enter a name',
    'rep.valType': 'Select the type',
    'rep.valValueInvalid': 'Invalid value',
    'rep.valValueNegative': 'Value cannot be negative',
  },
  es: {
    'rep.title': 'Informes',
    'rep.subtitle': 'Evolución en el tiempo — una fotografía por mes.',
    'rep.tabBudget': 'Presupuesto',
    'rep.tabNetworth': 'Patrimonio',
    'rep.periodMonths': '{n} meses',
    'rep.periodAll': 'Todo',
    'rep.noDataTitle': 'Aún no hay datos',
    'rep.networthEmptyDesc':
      'El gráfico de patrimonio se arma a partir de una fotografía mensual de tus cuentas e ítems. A medida que pasan los meses y se registra cada cierre, la evolución aparece aquí.',
    'rep.networthChartTitle': 'Patrimonio al final de cada mes',
    'rep.seriesAccountsCards': 'Cuentas + tarjetas',
    'rep.seriesItems': 'Ítems (inmuebles, préstamos)',
    'rep.seriesTotal': 'Patrimonio total',
    'rep.itemsNoteA': 'La línea de "Ítems" es constante en el pasado — a propósito.',
    'rep.itemsNoteB': 'Cuentas y tarjetas tienen un historial',
    'rep.itemsNoteC': 'real',
    'rep.itemsNoteD':
      '(reconstruido a partir de las transacciones), así que toda la variación que ves en el pasado viene de ellas. Los ítems (inmueble, FGTS, préstamos), en cambio, guardan solo el',
    'rep.itemsNoteE': 'valor actual',
    'rep.itemsNoteF': ': repetimos ese valor hacia atrás porque cambian poco, pero',
    'rep.itemsNoteG': 'no es una medición histórica',
    'rep.itemsNoteH':
      '— el préstamo amortizado y el FGTS rendido de meses anteriores no están reflejados. De ahora en adelante el valor se fotografía cada mes, y cualquier cambio en Patrimonio ya aparece aquí.',
    'rep.thMonth': 'Mes',
    'rep.thAccountsCards': 'Cuentas + tarjetas',
    'rep.thItems': 'Ítems',
    'rep.thTotal': 'Total',
    'rep.budgetEmptyDesc':
      'Este gráfico compara ingresos y gastos mes a mes. En cuanto registres transacciones o definas presupuestos, el sobrante de cada mes y la evolución acumulada aparecen aquí.',
    'rep.surplusMonthTitle': 'Sobrante del mes (ingresos − gastos)',
    'rep.projectFuture': 'Proyectar meses futuros',
    'rep.barDescA': 'Barras: verde = sobró · rojo = faltó ·',
    'rep.barDescB': 'hueca = proyección',
    'rep.barDescC': '. La línea es el',
    'rep.barDescD': 'sobrante acumulado',
    'rep.barDescE':
      '— la posición real de cuentas + tarjetas al final de cada mes, el mismo número que el Presupuesto hereda como "sobrante del mes anterior".',
    'rep.barName': 'Sobrante',
    'rep.lineAccumulated': 'Sobrante acumulado (cuentas + tarjetas)',
    'rep.thIncome': 'Ingresos',
    'rep.thExpenses': 'Gastos',
    'rep.thSurplus': 'Sobrante',
    'rep.thAccumulated': 'Acumulado',
    'rep.projectionBadge': 'proyección',
    'rep.nwTitle': 'Patrimonio',
    'rep.nwSubtitle': 'Net worth: cuentas + bienes − tarjetas − deudas, consolidado en {currency}.',
    'rep.nwNetWorthLabel': 'Patrimonio neto (net worth)',
    'rep.nwAssets': 'Activos',
    'rep.nwLiabilities': 'Pasivos',
    'rep.nwPartial': '* parcial: alguna moneda sin tasa en caché.',
    'rep.nwGroupCards': 'Tarjetas',
    'rep.nwGroupAccounts': 'Cuentas',
    'rep.nwDeleteConfirmTitle': '¿Eliminar "{name}"?',
    'rep.nwDeleteConfirmDesc': 'Esta acción no se puede deshacer.',
    'rep.nwItemDeleted': 'Ítem eliminado',
    'rep.nwDeleteError': 'Error al eliminar',
    'rep.nwSectionEmptyTitle': 'Aún no hay nada aquí',
    'rep.nwSectionEmptyDesc': 'Ningún ítem en {name} por ahora.',
    'rep.nwBadgeCard': 'tarjeta',
    'rep.nwBadgeAccount': 'cuenta',
    'rep.nwCreditSuffix': 'crédito',
    'rep.dlgEditTitle': 'Editar ítem',
    'rep.dlgNewTitle': 'Nuevo ítem de patrimonio',
    'rep.dlgDesc': 'El tipo define si es un activo (bien) o un pasivo (deuda) y lo agrupa en el resumen.',
    'rep.dlgTypeLabel': 'Tipo',
    'rep.dlgAssetsGroup': 'Activos (bienes)',
    'rep.dlgLiabilitiesGroup': 'Pasivos (deudas)',
    'rep.dlgAsset': 'Activo',
    'rep.dlgLiability': 'Pasivo',
    'rep.dlgExamples': '· ej.: {examples}',
    'rep.dlgNameLabel': 'Nombre',
    'rep.dlgNamePlaceholder': 'Ej.: Apartamento, Coche, Préstamo…',
    'rep.dlgValueLabel': 'Valor',
    'rep.dlgCurrencyLabel': 'Moneda',
    'rep.dlgNotesLabel': 'Observaciones',
    'rep.dlgNotesPlaceholder': 'Opcional',
    'rep.dlgItemUpdated': 'Ítem actualizado',
    'rep.dlgItemAdded': 'Ítem agregado',
    'rep.dlgSaveError': 'Error al guardar',
    'rep.valName': 'Ingresa un nombre',
    'rep.valType': 'Selecciona el tipo',
    'rep.valValueInvalid': 'Valor inválido',
    'rep.valValueNegative': 'El valor no puede ser negativo',
  },
}

export default reports
